import * as React from "react";
const SvgDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 8.56836L3 4.56836L9 4.56836L6 8.56836Z", fill: "#111314" }));
export default SvgDown;
